import React from "react";

import { localizer } from "../../../Translator";

import { Grid, Typography } from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import OutboxCli from "../../../sdk/OutboxCli";


export class ThumbnailImagePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Draft document internal identifier
      documentid: null,

      // Number document page requested to be displayed
      pagenumber: 1,

      // Number of the page in a single draft
      pageindraft: 1,

      // This flag determinate is current page is selected
      pageselected: false,

      // This flag determinate is current page is an initial shipment page
      initial: false,

      // This flag determinate is current page is exclude from the shipment
      excluded: false,

      //address:
      address: null,

      // Image content represents in base64 format
      base64: "",

      // This flag determinate if checkbox asociate to thumb image page is checked
      checked: false,

      // Error message to display in case of api calls fail
      errormessage: null,

      // These flag indicates if page options menu must be opened or closed
      optionsMenu: null,
      openMenu: false,

      isLoading: false
    }
  }

  componentDidMount() {
    if (this.props) {
      this.setState({
        documentid: this.props.documentid,
        pagenumber: this.props.pagenumber,
        pageindraft: this.props.pageindraft,
        pageselected: this.props.pageselected,
        initial: this.props.initial,
        excluded: this.props.excluded,
        address: this.props.address
      }, () => {
        this.getPageThumb()
      })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.documentid === prevProps.documentid &&
      this.props.pagenumber === prevProps.pagenumber &&
      this.props.pageindraft === prevProps.pageindraft &&
      this.props.pageselected === prevProps.pageselected &&
      this.props.initial === prevProps.initial &&
      this.props.excluded === prevProps.excluded &&
      this.props.address === prevProps.address) return
      
    this.setState({
      documentid: this.props.documentid,
      pagenumber: this.props.pagenumber,
      pageindraft: this.props.pageindraft,
      pageselected: this.props.pageselected,
      initial: this.props.initial,
      excluded: this.props.excluded,
      address: this.props.address
    }, () => {
      if (this.props.documentid !== prevProps.documentid) this.getPageThumb()
    })
  }

  getPageThumb = () => {
    this.setState({ isLoading: true })

    OutboxCli.GetDraftPageThumb(this.state.documentid, this.state.pageindraft).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ base64: response, errormessage: null })
      }

      this.setState({ isLoading: false })
    })
  }

  doDisplayPage = () => {
    this.props.doDisplayPage(this.state.pagenumber)
  }

  /* Page menu options functions*/
  handleClickOptionsMenu = (event) => {
    this.setState({ optionsMenu: event.currentTarget, openMenu: true });
  }

  handleOpenOptionsMenu = () => {
    this.setState({ openMenu: true })
  }
  handleCloseOptionsMenu = () => {
    this.setState({ openMenu: false })
  }

  render() {
    const pagename = this.state.initial ? localizer.Shipment : localizer.Page + " " + this.state.pageindraft
    const initialpageclass = (this.state.initial && this.state.address !== null) ? "initial-page" : ""
    const errorAddressclass = ( this.state.initial && this.state.address === null) ? "initial-page-error" : ""
    const excludedpageclass = this.state.excluded ? "excluded-page" : ""
    const excludedpageoption = this.state.excluded ? localizer.IncludePage : localizer.ExcludePage
    const initialpageoption = this.state.initial ? localizer.MultiShipmentUnmarkAsInitialPage : localizer.MultiShipmentMarkAsInitialPage
    
    return (
      <React.Fragment>

        <Grid item md={10}>
          <img className={"viewer-container cursor-pointer "  +  initialpageclass + " " + excludedpageclass +" " + errorAddressclass} src={"data:image/png;base64, " + this.state.base64} alt="" width={95} onClick={this.doDisplayPage}></img>
          <Typography className="typography-generic text-align-center">{pagename}</Typography>
        </Grid>
        {this.state.pageselected &&
          <Grid item md={2}>
            <IconButton style={{width:"20px", height:"20px"}} aria-label="more" aria-controls="page-options" aria-haspopup="true" onClick={this.handleClickOptionsMenu}>
              <i className="fa-solid fa-ellipsis-vertical"></i>
            </IconButton>
            <Menu id="page-options" anchorEl={this.state.optionsMenu} keepMounted open={this.state.openMenu} onClose={this.handleCloseOptionsMenu} >
              <MenuItem key="initialpage-option" onClick={() => { this.props.doToggleInitialPage(); this.handleCloseOptionsMenu() }}>
                <Typography className="typography-generic small">{initialpageoption}</Typography>
              </MenuItem>
              <MenuItem key="includeexcludepage-option" onClick={() => { this.props.doToggleExcludePage(); this.handleCloseOptionsMenu() }}>
                <Typography className="typography-generic small">{excludedpageoption}</Typography>
              </MenuItem>
            </Menu>
          </Grid>
        }

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/multishipment/ThumbnailImagePage.js